import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SiteSettingsContext = createContext(null);

const FALLBACK = {
  general: {
    site_name: "SHAMSTRADE",
    tagline: "Mastering Climate",
  logo_url: "/icons/icon-512.png",
    whatsapp_number: "962799448817",
    phone: "+962 79 944 8817",
    email: "info@shams-trade.com",
    currency_symbol: "د.ا",
  },
  hero: {
    eyebrow: "Climate engineering · Middle East",
    headline_line1: "MASTERING",
    headline_line2: "CLIMATE.",
    headline_line3: "ROOM BY ROOM.",
    subheadline: "Premium air conditioners.",
    cta_primary_label: "Shop the catalog",
    cta_primary_link: "/shop",
    cta_secondary_label: "Today's deals",
    cta_secondary_link: "/shop?on_sale=true",
    stats: [],
  },
  marquee: [],
  trust_badges: [],
  categories: [],
  sections: {},
  footer: {},
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/site-settings");
      setSettings({ ...FALLBACK, ...data });
    } catch {
      setSettings(FALLBACK);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const update = async (partial) => {
    const { data } = await api.put("/admin/site-settings", partial);
    setSettings({ ...FALLBACK, ...data });
    return data;
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loaded, refresh: load, update }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
